import React from 'react';
import _ from 'underscore';
import { Segment, Accordion, Icon, Table, Grid, Container } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import moment from 'moment';

const styleFilename = {
    display: "inline-block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "600px",
    verticalAlign: "middle"
}

class UploadUserResult extends React.Component {

    state = {
        isVisible: false,
    }

    toggleAccordion() {
        this.setState({isVisible:!this.state.isVisible});
    }

    render() {

        const job = this.props.job;
        if(!job) return "No Data";

        return (
            <>
                <Segment style={{margin:"2.5rem 0"}}>
                    <Accordion >
                        <Accordion.Title
                            active={this.state.isVisible}
                            onClick={this.toggleAccordion.bind(this)}
                        >
                            <Icon name='dropdown' />
                            { job.status === "PROCESSING" ? <span style={{color:"#fca136"}}>[Processing]</span> : <span style={{color:"#56c829"}}>[Complete]</span> }
                            &nbsp;&nbsp;
                            <strong style={styleFilename}>
                                {job.result.filename || "Unknown File Name"}
                            </strong>
                            <div style={{ float: "right" }}> 
                                Uploaded by <strong>{job.user.name}</strong> on { moment(job.created, 'x').format("DD-MMM-YYYY kk:mm")} 
                            </div>

                        </Accordion.Title>
                        <Accordion.Content active={this.state.isVisible}>
                            <br />

                            { job.status === "PROCESSING" && 
                                <Container fluid={true} style={{padding:"0 20px"}}>Processing . . .</Container>
                            }

                            { job.status === "COMPLETE" &&
                            <Container fluid={true} style={{padding:"0 20px"}}>
                                <Grid columns={2}>
                                    <Grid.Row>
                                        <Grid.Column width={16}>
                                            <p> Total Rows Processed: {job.result.numOfRowsProcessed} </p>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <p> Number of Employee Processed: {job.result.numOfUsersProcessed}</p>
                                            <p> Number of Employee Created: {job.result.numOfUsersCreated} </p>
                                            <p> Number of Employee Updated: {job.result.numOfUsersUpdated} </p>
                                            <p> Number of Employee Terminated: {job.result.numOfUsersTerminated} </p>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p> Number of Dependent Processed: {job.result.numOfDependentsProcessed} </p>
                                            <p> Number of Dependent Created: {job.result.numOfDependentsCreated} </p>
                                            <p> Number of Dependent Updated: {job.result.numOfDependentsUpdated} </p>
                                            <p> Number of Dependent Terminated: {job.result.numOfDependentsTerminated}</p>
                                        </Grid.Column>
                                    </Grid.Row>
                                    {/* Display user rejected */}
                                    <Grid.Row>
                                        <Grid.Column width={16}>
                                            <p> Rejected Data: {Array.isArray(job.result.usersRejected) ? job.result.usersRejected.length : "0"} </p>
                                            {Array.isArray(job.result.usersRejected) && job.result.usersRejected.length > 0 &&
                                                <Table>
                                                    <Table.Header>
                                                        <Table.Row>
                                                            <Table.HeaderCell>Name</Table.HeaderCell>
                                                            <Table.HeaderCell>Error</Table.HeaderCell>
                                                        </Table.Row>
                                                    </Table.Header>
                                                    <Table.Body>
                                                        {   Array.isArray(job.result.usersRejected) &&
                                                            _.map(job.result.usersRejected, (rejected, index) => {
                                                                const { name, error } = rejected;
                                                                return (
                                                                    <Table.Row key={index}>
                                                                        <Table.Cell>
                                                                            {name}
                                                                        </Table.Cell>
                                                                        <Table.Cell>
                                                                            {error}
                                                                        </Table.Cell>
                                                                    </Table.Row>
                                                                );
                                                            })
                                                        }
                                                    </Table.Body>
                                                </Table>
                                            }

                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                                <br/>
                            </Container>
                            }

                        </Accordion.Content>
                    </Accordion>
                </Segment>
            </>
        )
    }

}

export default UploadUserResult;